import { createApp } from 'vue'
import App from './App.vue'
import 'amfe-flexible'
createApp(App).mount('#app')
